import * as React from "react"
import {Box} from "@mui/material";

import SkipButton from "./SkipButton";
import EditButton from "./EditButton";


export default function actionsColumn() {
	return {
		name: "productID", label: "Actions",
		options: {
			headerAlign: 'center',
			filter: false,
			sort: false,
			customBodyRowRenderLite: (value, rowData) => <Box sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				gap: 1
			}}>
				<EditButton rowData={rowData} />
				<SkipButton rowData={rowData} />
			</Box>
		}
	}
}
